/**
 * Querformat-Sperre (Masterprompt Abschnitt 7).
 *
 * Ein Match laeuft ausschliesslich im Querformat. Haelt der Spieler das Geraet
 * hochkant, zeigen wir eine einfache Aufforderung - es gibt bewusst KEINE
 * eigene Hochkant-Oberflaeche fuer das Spiel.
 */

import { useEffect, useState, type ReactNode } from 'react';
import { t } from '../i18n/index.js';
import { MenueHintergrund } from './MenueHintergrund.js';
import { MENUE_LOGO } from './menueBilder.js';

/** Prueft, ob das Fenster gerade hochkant ist. */
function isPortrait(): boolean {
  if (typeof window === 'undefined') return false;
  return window.innerHeight > window.innerWidth;
}

export function OrientationGate({ children }: { children: ReactNode }) {
  const [portrait, setPortrait] = useState(isPortrait);

  useEffect(() => {
    const handle = () => setPortrait(isPortrait());
    window.addEventListener('resize', handle);
    window.addEventListener('orientationchange', handle);
    return () => {
      window.removeEventListener('resize', handle);
      window.removeEventListener('orientationchange', handle);
    };
  }, []);

  if (portrait) {
    return (
      <div className="dl-orientation">
        {/* Dasselbe Bild wie im Menue, stark abgedunkelt (15.10.2026). */}
        <MenueHintergrund />
        {/* Der Schriftzug oben (15.10.2026) - man sieht sofort, wo man ist. */}
        <picture className="dl-orientation__logo">
          <source type="image/avif" srcSet={MENUE_LOGO.avif} sizes="75vw" />
          <source type="image/webp" srcSet={MENUE_LOGO.webp} sizes="75vw" />
          <img src={MENUE_LOGO.ersatz} alt={t.menu.title} />
        </picture>
        <div className="dl-orientation__icon" />
        <h1 className="dl-status__headline">{t.orientation.title}</h1>
        <p className="dl-status__detail">{t.orientation.hint}</p>
      </div>
    );
  }

  return <>{children}</>;
}
